import { Injectable } from '@angular/core';
import { ExecutionResult, LcsApiService } from '@lcs/shared/api';
import { Observable } from 'rxjs';
import { createExtensionInput } from 'src/app/common-components/helpers/extension-helper';
import { ExtensionDetailSaveEvent } from '../../extension-details/models/extension-detail-form-submit-event';
import { SaveExtension, SaveExtensionVariables } from '../../extension-details/queries/generated/SaveExtension';
import { SaveExtensionMutation } from '../../extension-details/queries/save-extension.graphql';

@Injectable({ providedIn: 'root' })
export class AddExtensionApiService {
   constructor(private apiService: LcsApiService) {}

   create(extensionDetailSaveEvent: ExtensionDetailSaveEvent): Observable<ExecutionResult<SaveExtension>> {
      const extension = createExtensionInput(
         extensionDetailSaveEvent.extension,
         extensionDetailSaveEvent.extensionFields,
         extensionDetailSaveEvent.extensionPhoneFields,
         extensionDetailSaveEvent.extensionPagingGroupFields,
         extensionDetailSaveEvent.extensionExternalForwardFields,
         extensionDetailSaveEvent.extensionAutoAttendantFields,
         extensionDetailSaveEvent.extensionHuntGroupFields,
         extensionDetailSaveEvent.extensionMailboxFields,
         extensionDetailSaveEvent.mailboxFields,
         extensionDetailSaveEvent.extensionQueueFields,
         extensionDetailSaveEvent.extensionFaxFields,
         extensionDetailSaveEvent.extensionFindMeFollowMeFields,
         false
      );
      const variables: SaveExtensionVariables = {
         deletedAutoAttendantKeyIds: [],
         deletedAutoAttendantPromptIds: [],
         deletedHuntGroupMemberIds: [],
         deletedPhoneIds: [],
         deletedQueueMemberIds: [],
         deletedQueuePeriodicAnnouncementIds: [],
         deletedTimeBasedRouteIds: [],
         deletedExtensionSuperviseeIds: [],
         deletedExtensionQueueGroupIds: [],
         deletedExtensionHuntGroupIds: [],
         deletedExtensionGroupSuperviseeIds: [],
         deletedFaxEmailAddressIds: [],
         deletedDepartmentExtensionIds: [],
         deletedFmFmSteps: [],
         deletedFmFmStepExtensions: [],
         deletedFmFmStepPhoneNumbers: [],
         deletedBaseStationHandsetIds: [],
         deletedPagingGroupExtensionGroupIds: [],
         deletedPagingGroupMemberIds: [],
         deletedNoteIds: [],

         extension: extension,
      };
      return this.apiService.query<SaveExtension, SaveExtensionVariables>({
         query: SaveExtensionMutation,
         variables: variables,
      });
   }
}
